import React from "react";
import { Helmet } from "react-helmet";
import portfolio from "../content/portfolio.json";

const { meta } = portfolio;

const PageHelmet = ({ title, description = meta.metaDescription }) => (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/images/myphoto.jpg" />
        <link rel="icon" href="/images/icon.png" type="image/png" />
    </Helmet>
);

export default PageHelmet;
